import React, { Dispatch, ElementType, SetStateAction } from 'react';

import { Report } from '@mui/icons-material';
import { Box, SvgIconProps, Typography } from '@mui/material';

import { BLOCK_TYPE } from '../../../utils/constants/block';
import { FileState } from '../../../utils/models/common-models';
import CommonBlocks from './CommonBlocks';
import DataEnricherApi from './DataEnricherApi';
import Evaluator from './Evaluator';


const WarningMessage = ({ Icon, iconColor, iconSize, message }: {
    Icon: ElementType<SvgIconProps>;
    iconColor: SvgIconProps['color'];
    iconSize: SvgIconProps['fontSize'];
    message: string;
}) => {
    return (
        <Box sx={{ height: '70%', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
            <Icon color={iconColor} fontSize={iconSize} />
            <Typography variant="h5">
                {message}
            </Typography>
        </Box>
    )
}

interface BlockTypeEditorsProps {
    blockType: string | undefined;
    selectedFile: string;
    fileStates: FileState;
    setFileStates: Dispatch<SetStateAction<FileState>>;
}

const BlockTypeEditors: React.FC<BlockTypeEditorsProps> = ({
    blockType,
    selectedFile,
    fileStates,
    setFileStates,
}) => {

    const renderEditors = () => {
        const commonProps = {
            selectedFile,
            fileStates,
            setFileStates
        };

        switch (blockType) {
            case BLOCK_TYPE.DataEnricher_API:
                return <DataEnricherApi {...commonProps} />

            case BLOCK_TYPE.Evaluator:
                return <Evaluator {...commonProps} />

            default:
                return <CommonBlocks {...commonProps} />
        }
    }

    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            {!selectedFile && (
                <WarningMessage Icon={Report} iconColor='warning' iconSize='large' message='Select a file to view its content.' />
            )}

            {selectedFile &&
                !selectedFile.endsWith('.py') &&
                !selectedFile.endsWith('.md') &&
                !selectedFile.endsWith('.json') &&
                !selectedFile.endsWith('.txt') &&
                selectedFile !== 'Dockerfile' &&
                (
                    <WarningMessage Icon={Report} iconColor='error' iconSize='large' message='Unsupported file type.' />
                )}

            {
                blockType && !Object.values(BLOCK_TYPE).includes(blockType as BLOCK_TYPE) ?
                    <WarningMessage Icon={Report} iconColor='error' iconSize='large' message='Block type not found.' />
                    :
                    renderEditors()
            }
        </Box>
    )
}

export default BlockTypeEditors